import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from '@cbridge-utils/react-redux';
import { NavigationHeaderCreateButton } from '@cbridge-tools/navigation-block';
import { PolicyProtection } from '@cbridge-packages/auth';
import { MarkupProfileAction } from '@cbridge-packages/markup-profile';
import { useDialogs } from '@cbridge-modules/dialog';
import { MarkupProfileFormDialog } from '../_dialogs/MarkupProfileFormDialog';

export const CreateMarkupProfileButton: FunctionComponent = () => {
  const { t } = useTranslation();

  const dialogs = useDialogs();

  const dispatch = useDispatch();

  const handleCreateMarkupProfile = async () => {
    const success = await dialogs.open(MarkupProfileFormDialog);

    if (success) {
      dispatch(MarkupProfileAction.loadList.started());
    }
  };

  return (
    <PolicyProtection>
      <NavigationHeaderCreateButton
        label={t('text:configPage.markups.dialog.create.title')}
        onClick={handleCreateMarkupProfile}
      />
    </PolicyProtection>
  );
};
